import React from "react";

import MainNewProdut from '../components/MainNewProdut';

const NewProduct = ()=>{

    return <MainNewProdut />
}

export default NewProduct;